/* ==========================================================================
   DEEN - Men's Mix & Match: keeps the mobile CTA clear of bottom chrome.

   Measures any fixed element pinned to the bottom of the viewport that is not
   part of this builder - the Shopify theme preview bar, a theme sticky footer,
   a consent bar - and publishes its height as --dmm-bottom-chrome on <html>.
   deen-mm-men-mobile-cta.css adds that height to the sticky bar's bottom
   padding, so the Add bundle to cart button is never covered.

   It reads the page and writes one custom property. It never touches the
   builder state, the gift selector, the cart flow or any discount logic, and
   it binds no listener to any CTA.
   ========================================================================== */

(function () {
  "use strict";

  var KNOWN = "#PBarNextFrameWrapper,#PBarNextFrame,.shopify-preview-bar,#preview-bar-iframe";
  /* A consent dialog is not chrome: the shopper answers it and it is gone, and
     reserving its height would leave a large empty gap under the bar. */
  var IGNORE = "#shopify-pc__banner,.shopify-pc__banner,[id*='consent'],[id*='cookie']";
  /* Real bottom chrome is a strip. Anything taller is something else. */
  var CAP = 160;
  var last = null;
  var queued = false;

  function root() {
    return document.querySelector(".deen-mm-men");
  }

  function candidates() {
    var out = [];
    var i;
    var known = document.querySelectorAll(KNOWN);
    for (i = 0; i < known.length; i++) out.push(known[i]);
    var kids = document.body ? document.body.children : [];
    for (i = 0; i < kids.length; i++) out.push(kids[i]);
    return out;
  }

  function measure() {
    queued = false;
    if (!document.body || !root()) return;

    var viewport = window.innerHeight || 0;
    if (!viewport) return;

    var nodes = candidates();
    var height = 0;
    var i, el, style, rect, visible;

    for (i = 0; i < nodes.length; i++) {
      el = nodes[i];
      if (!el || el.nodeType !== 1) continue;
      /* Never measure our own bar or toast. */
      if (el.closest && el.closest(".deen-mm-men")) continue;
      try {
        if (el.matches && el.matches(IGNORE)) continue;
        if (el.querySelector && el.querySelector(IGNORE)) continue;
      } catch (e) {}
      if (el.tagName === "SCRIPT" || el.tagName === "STYLE" || el.tagName === "LINK") continue;

      try {
        style = window.getComputedStyle(el);
      } catch (e) {
        continue;
      }
      if (!style || style.position !== "fixed") continue;
      if (style.display === "none" || style.visibility === "hidden") continue;
      if (parseFloat(style.opacity) === 0) continue;

      rect = el.getBoundingClientRect();
      if (!rect || rect.height < 8 || rect.width < 40) continue;
      /* A full-screen overlay is not bottom chrome. */
      if (rect.height > viewport * 0.5) continue;
      /* Must actually sit against the bottom edge. */
      if (rect.bottom < viewport - 4) continue;
      if (rect.top >= viewport) continue;

      visible = Math.round(viewport - rect.top);
      if (visible > height) height = visible;
    }

    if (height > CAP) height = CAP;
    if (height === last) return;
    last = height;
    document.documentElement.style.setProperty("--dmm-bottom-chrome", height + "px");
  }

  function schedule() {
    if (queued) return;
    queued = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(measure);
    else setTimeout(measure, 16);
  }

  function start() {
    if (!root()) return;
    measure();

    window.addEventListener("resize", schedule, { passive: true });
    window.addEventListener("orientationchange", schedule, { passive: true });
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("load", schedule);

    if (window.visualViewport && window.visualViewport.addEventListener) {
      window.visualViewport.addEventListener("resize", schedule, { passive: true });
      window.visualViewport.addEventListener("scroll", schedule, { passive: true });
    }

    /* The preview bar is injected after the theme renders. */
    if (window.MutationObserver && document.body) {
      new MutationObserver(schedule).observe(document.body, { childList: true });
    }

    setTimeout(measure, 400);
    setTimeout(measure, 1200);
    setTimeout(measure, 3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
